var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9461 6.81356C26.9461 10.5766 22.9408 13.6271 18 13.6271C13.0592 13.6271 9.05389 10.5766 9.05389 6.81356C9.05389 3.05053 13.0592 0 18 0C22.9408 0 26.9461 3.05053 26.9461 6.81356Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8922 13.7288C17.8922 17.4918 13.8869 20.5424 8.94611 20.5424C4.00531 20.5424 0 17.4918 0 13.7288C0 9.96579 4.00531 6.91525 8.94611 6.91525C13.8869 6.91525 17.8922 9.96579 17.8922 13.7288Z",
    fill: "#A8A8A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7844 10.2712C35.7844 14.0342 31.7791 17.0847 26.8383 17.0847C21.8975 17.0847 17.8922 14.0342 17.8922 10.2712C17.8922 6.50816 21.8975 3.45763 26.8383 3.45763C31.7791 3.45763 35.7844 6.50816 35.7844 10.2712Z",
    fill: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 17.1864C36 20.9495 31.9947 24 27.0539 24C22.1131 24 18.1078 20.9495 18.1078 17.1864C18.1078 13.4234 22.1131 10.3729 27.0539 10.3729C31.9947 10.3729 36 13.4234 36 17.1864Z",
    fill: "#A8A8A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.006 17.1864C25.006 20.9495 21.0007 24 16.0599 24C11.1191 24 7.11377 20.9495 7.11377 17.1864C7.11377 13.4234 11.1191 10.3729 16.0599 10.3729C21.0007 10.3729 25.006 13.4234 25.006 17.1864Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudZero);
export default __webpack_public_path__ + "static/media/CloudZero.e0e76cbc90d61fc2cfce76e94c3b382d.svg";
export { ForwardRef as ReactComponent };